import { useGetCurrentUser } from 'hooks/useGetCurrentUser';
import { useViewer } from 'hooks/useViewer';
import { useSetPlayerFinderOnboardedMutation } from 'types/generated/client';

/**
 * Whether the viewer has been through the Find players questionnaire, backed by
 * `users.player_finder_onboarded_at`. Drives the home banner: first-timers get
 * the questionnaire, everyone else goes straight to the Players tab.
 *
 * The mutation returns the field, so Apollo updates the cached user and
 * `hasCompletedOnboarding` flips without a manual refetch.
 */
export const useFindPlayersOnboarding = () => {
  const { userId } = useViewer();
  const { user } = useGetCurrentUser();
  const [setOnboarded] = useSetPlayerFinderOnboardedMutation();

  const hasCompletedOnboarding = !!user?.playerFinderOnboardedAt;

  const completeOnboarding = async () => {
    if (!userId || hasCompletedOnboarding) {
      return;
    }

    await setOnboarded({ variables: { id: userId, onboardedAt: new Date().toISOString() } });
  };

  return { hasCompletedOnboarding, completeOnboarding };
};
